import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Layout from "../components/Layout";
import API_BASE from "../config.js";
import { Dica, BotaoDica } from "../components/Dica";
import { useTranslation } from "react-i18next";
import useTextosSegmento from "../i18n/useTextosSegmento";
import { authFetch } from "../services/authFetch";


// Extrai tenant_id do JWT token - evita conflito entre tenants
function getTenantIdFromToken() {
  try {
    const token = (sessionStorage.getItem("access_token")||localStorage.getItem("access_token"));
    if (!token) return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1";
    const payload = JSON.parse(atob(token.split(".")[1]));
    return String(payload.tenant_id || (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1");
  } catch { return (sessionStorage.getItem("tenant_id")||localStorage.getItem("tenant_id")) || "1"; }
}

const API = "" + API_BASE + "/api/v1/dados";

const STATUS_COR = {
  "Recepcao":"#6366f1","Diagnostico":"#f59e0b","Aguardando Aprovacao":"#f97316",
  "Em Servico":"#3b82f6","Aguardando Pecas":"#eab308","Concluido":"#22c55e","Entregue":"#94a3b8"
};

export default function Orcamentos() {
  const { t } = useTranslation();
  // AUD-E: t() sensivel ao segmento. Usado SO nas chamadas de
  // vocabulario de veiculo; o resto da tela segue no t() de sempre.
  const { tSeg } = useTextosSegmento();
  const STATUS_LABEL = (s) => t("os.status." + s, s);
  const navigate = useNavigate();
  const tenantId = getTenantIdFromToken() || "1";
  const CACHE_KEY = "orcamentos_cache_tenant_" + tenantId;
  const ARQUIVO_KEY = "orcamentos_arquivados_" + tenantId;

  const [orcamentos, setOrcamentos] = useState([]);
  const [arquivados, setArquivados] = useState(() => {
    try { return JSON.parse(localStorage.getItem(ARQUIVO_KEY) || "[]"); } catch { return []; }
  });
  const [loading, setLoading] = useState(true);
  const [busca, setBusca] = useState("");
  const [modalVer, setModalVer] = useState(null);
  const [verArquivados, setVerArquivados] = useState(false);
  const [confirmLimpar, setConfirmLimpar] = useState(false);

  useEffect(() => {
    try { const c = JSON.parse(localStorage.getItem(CACHE_KEY)||"[]"); if(c.length>0) setOrcamentos(c); } catch{}
    authFetch(API + "/os/" + tenantId, {})
      .then(r=>r.ok?r.json():[])
      .then(d=>{
        if(Array.isArray(d)){
          const comOrc = d.filter(o=>o.orcamento);
          setOrcamentos(comOrc);
          try { localStorage.setItem(CACHE_KEY, JSON.stringify(comOrc)); } catch (e) { console.warn("orcamentos cache setItem failed (non-fatal):", e); }
          // Sincronizar arquivados do banco - fonte de verdade
          const arqDoBanco = comOrc.filter(o=>o.arquivado===true||o.arquivado==="t"||o.arquivado===1).map(o=>o.id);
          if(arqDoBanco.length>0){
            setArquivados(prev=>{
              const merged = [...new Set([...prev,...arqDoBanco])];
              try { localStorage.setItem(ARQUIVO_KEY, JSON.stringify(merged)); } catch (e) { console.warn("orcamentos cache setItem failed (non-fatal):", e); }
              return merged;
            });
          }
        }
      })
      .catch(()=>{})
      .finally(()=>setLoading(false));
  }, []);

  const arquivar = (id) => {
    const novos = [...arquivados, id];
    setArquivados(novos);
    localStorage.setItem(ARQUIVO_KEY, JSON.stringify(novos));
    setModalVer(null);
  };

  const desarquivar = (id) => {
    const novos = arquivados.filter(a => a !== id);
    setArquivados(novos);
    localStorage.setItem(ARQUIVO_KEY, JSON.stringify(novos));
  };

  const limparArquivados = () => {
    setArquivados([]);
    localStorage.removeItem(ARQUIVO_KEY);
    setConfirmLimpar(false);
  };

  const exportarPDF = (o) => {
    let orc = null;
    try { orc = JSON.parse(o.orcamento); } catch{}
    const itens = orc ? orc.itens || [] : [];
    const html = `<!DOCTYPE html><html><head><meta charset="utf-8"><title>${t("orcamentos.modal_orcamento_label")} ${o.id}</title>
    <style>body{font-family:Arial,sans-serif;padding:32px;color:#1e293b}h1{color:#1e40af;font-size:20px}
    table{width:100%;border-collapse:collapse;margin-top:16px}th{background:#1e40af;color:#fff;padding:10px;text-align:left}
    td{padding:9px;border-bottom:1px solid #e2e8f0}.total{text-align:right;font-size:18px;font-weight:bold;color:#1e40af;margin-top:16px}
    .info{display:grid;grid-template-columns:1fr 1fr;gap:12px;margin:16px 0}.info-box{background:#f8fafc;padding:12px;border-radius:8px}
    .label{font-size:10px;font-weight:700;text-transform:uppercase;color:#64748b;margin-bottom:4px}</style></head>
    <body><h1>${t("orcamentos.modal_orcamento_label")} - ${o.id}</h1><div class="info">
    <div class="info-box"><div class="label">${t("orcamentos.print_cliente")}</div><div>${o.cliente}</div><div style="color:#64748b;font-size:12px">${o.telefone||""}</div></div>
    <div class="info-box"><div class="label">${tSeg("orcamentos.info_veiculo")}</div><div>${o.veiculo}</div><div style="color:#1e40af;font-weight:700">${o.placa||""}</div></div>
    <div class="info-box"><div class="label">${t("orcamentos.info_status")}</div><div>${STATUS_LABEL(o.status)}</div></div>
    <div class="info-box"><div class="label">${t("orcamentos.info_data")}</div><div>${o.criada||""}</div></div></div>
    <table><thead><tr><th>${t("orcamentos.col_servico_peca")}</th><th>${t("orcamentos.col_qtd")}</th><th>${t("orcamentos.print_valor")}</th></tr></thead><tbody>
    ${itens.map(i=>`<tr><td>${i.nome}</td><td>${i.qtd||1}</td><td>R$ ${Number(i.preco).toFixed(2)}</td></tr>`).join("")}
    </tbody></table><div class="total">${t("orcamentos.print_total_prefix")} R$ ${(o.total||0).toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
    <div style="margin-top:40px;display:grid;grid-template-columns:1fr 1fr;gap:40px">
    <div style="text-align:center;border-top:1px solid #94a3b8;padding-top:8px;font-size:12px;color:#64748b">${t("orcamentos.print_assinatura_responsavel")}</div>
    <div style="text-align:center;border-top:1px solid #94a3b8;padding-top:8px;font-size:12px;color:#64748b">${t("orcamentos.print_assinatura_cliente")}</div></div>
    </body></html>`;
    const w = window.open("","_blank");
    w.document.write(html);
    w.document.close();
    w.print();
  };

  const listaBase = verArquivados
    ? orcamentos.filter(o => arquivados.includes(o.id))
    : orcamentos.filter(o => !arquivados.includes(o.id));

  const filtrados = listaBase.filter(o =>
    !busca ||
    o.cliente?.toLowerCase().includes(busca.toLowerCase()) ||
    o.id?.toLowerCase().includes(busca.toLowerCase()) ||
    o.placa?.toLowerCase().includes(busca.toLowerCase())
  );

  // Busca global inclui arquivados
  const filtradosBusca = busca
    ? orcamentos.filter(o =>
        o.cliente?.toLowerCase().includes(busca.toLowerCase()) ||
        o.id?.toLowerCase().includes(busca.toLowerCase()) ||
        o.placa?.toLowerCase().includes(busca.toLowerCase())
      )
    : filtrados;

  return (
    <Layout>
      <div style={{display:"flex",flexDirection:"column",gap:20}}>
        <div style={{alignItems:"flex-start",display:"flex",justifyContent:"space-between",flexWrap:"wrap",gap:10}}>
          <div>
            <div style={{alignItems:"center",display:"flex",gap:8}}><h1 style={{fontSize:22,fontWeight:700}}>{t("orcamentos.titulo")}</h1><BotaoDica id="orcamentos" /></div>
            <p style={{color:"var(--text2)",fontSize:13,marginTop:3}}>
              {t("orcamentos.ativos",{count:orcamentos.filter(o=>!arquivados.includes(o.id)).length})}
              {arquivados.length>0&&<span style={{color:"var(--text3)",marginLeft:8}}>{t("orcamentos.arquivados_count",{count:arquivados.length})}</span>}
            </p>
          </div>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            <button onClick={()=>setVerArquivados(v=>!v)}
              style={{background:verArquivados?"#f59e0b22":"var(--bg3)",border:"1px solid "+(verArquivados?"#f59e0b":"var(--border)"),borderRadius:8,color:verArquivados?"#f59e0b":"var(--text2)",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>
              {verArquivados?t("orcamentos.ver_ativos"):t("orcamentos.ver_arquivados")} {arquivados.length>0&&`(${arquivados.length})`}
            </button>
            {verArquivados&&arquivados.length>0&&(
              <button onClick={()=>setConfirmLimpar(true)}
                style={{background:"#ef444422",border:"1px solid #ef4444",borderRadius:8,color:"#ef4444",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>
                {t("orcamentos.limpar_arquivados")}
              </button>
            )}
          </div>
        </div>

        <Dica id="orcamentos" jaUsou={orcamentos.length > 0}
          texto={t("dicas.orcamentos", "Elabore orçamentos detalhados com peças e mão de obra e envie direto para o WhatsApp do cliente, com a identidade visual da sua marca.")} />

        <input placeholder={t("orcamentos.buscar_placeholder")}
          value={busca} onChange={e=>setBusca(e.target.value)}
          style={{borderRadius:8,border:"1px solid var(--border)",background:"var(--bg3)",color:"var(--text)",fontSize:13,padding:"10px 14px",width:"100%",maxWidth:500}}
        />

        {busca && (
          <div style={{color:"var(--text3)",fontSize:12}}>
            {t("orcamentos.buscando_resultados",{count:filtradosBusca.length})}
          </div>
        )}

        {loading ? (
          <div style={{color:"var(--text3)",fontSize:14,padding:"40px 0",textAlign:"center"}}>{t("common.carregando")}</div>
        ) : (busca?filtradosBusca:filtrados).length === 0 ? (
          <div style={{color:"var(--text3)",fontSize:14,padding:"40px 0",textAlign:"center"}}>
            <div style={{fontSize:40,marginBottom:12}}>📋</div>
            {busca?t("orcamentos.nenhum_encontrado"):verArquivados?t("orcamentos.nenhum_arquivado"):t("orcamentos.nenhum_salvo")}
          </div>
        ) : (
          <div style={{display:"flex",flexDirection:"column",gap:10}}>
            {(busca?filtradosBusca:filtrados).map(o => {
              let orc = null;
              try { orc = JSON.parse(o.orcamento); } catch{}
              const isArquivado = arquivados.includes(o.id);
              return (
                <div key={o.id} className="card" style={{cursor:"pointer",opacity:isArquivado?0.6:1}} onClick={()=>navigate("/orcamentos/"+o.id)}>
                  <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",gap:12}}>
                    <div>
                      <div style={{display:"flex",alignItems:"center",gap:8,marginBottom:4,flexWrap:"wrap"}}>
                        <span style={{color:"var(--accent)",fontFamily:"monospace",fontSize:13,fontWeight:700}}>{o.id}</span>
                        <span style={{background:(STATUS_COR[o.status]||"#6366f1")+"22",borderRadius:6,color:STATUS_COR[o.status]||"#6366f1",fontSize:11,fontWeight:600,padding:"2px 8px"}}>{STATUS_LABEL(o.status)}</span>
                        {orc&&<span style={{background:"#f59e0b22",borderRadius:6,color:"#f59e0b",fontSize:11,fontWeight:600,padding:"2px 8px"}}>{orc.modelo||"basico"}</span>}
                        {isArquivado&&<span style={{background:"#64748b22",borderRadius:6,color:"#64748b",fontSize:11,padding:"2px 8px"}}>{t("orcamentos.badge_arquivado")}</span>}
                      </div>
                      <div style={{fontSize:14,fontWeight:700}}>{o.cliente}</div>
                      <div style={{color:"var(--text2)",fontSize:12,marginTop:2}}>{o.veiculo}{o.placa?" · "+o.placa:""}</div>
                    </div>
                    <div style={{textAlign:"right"}}>
                      <div style={{color:"#22c55e",fontSize:16,fontWeight:800}}>R$ {(o.total||0).toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
                      <div style={{color:"var(--text3)",fontSize:11,marginTop:2}}>{o.criada}</div>
                    </div>
                  </div>
                  {orc&&orc.itens&&(
                    <div style={{borderTop:"1px solid var(--border)",marginTop:10,paddingTop:10}}>
                      <div style={{color:"var(--text3)",fontSize:11,marginBottom:4}}>{t("orcamentos.itens_label")}</div>
                      <div style={{display:"flex",flexWrap:"wrap",gap:6}}>
                        {orc.itens.slice(0,5).map((item,i)=>(<span key={i} style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:6,color:"var(--text2)",fontSize:11,padding:"2px 8px"}}>{item.nome}</span>))}
                        {orc.itens.length>5&&<span style={{color:"var(--text3)",fontSize:11}}>{t("orcamentos.mais",{count:orc.itens.length-5})}</span>}
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}

        {/* MODAL DETALHE */}
        {modalVer && (
          <div style={{alignItems:"flex-start",background:"#0009",bottom:0,display:"flex",justifyContent:"center",left:0,overflowY:"auto",position:"fixed",right:0,top:0,zIndex:999,padding:"40px 20px 40px 260px"}} onClick={()=>setModalVer(null)}>
            <div style={{background:"var(--bg)",borderRadius:16,maxWidth:900,padding:28,width:"100%",margin:"auto"}} onClick={e=>e.stopPropagation()}>
              <div style={{alignItems:"center",display:"flex",justifyContent:"space-between",marginBottom:20,flexWrap:"wrap",gap:10}}>
                <div>
                  <div style={{color:"var(--accent2)",fontSize:12,marginBottom:2}}>{t("orcamentos.modal_orcamento_label")}</div>
                  <div style={{fontSize:18,fontWeight:800}}>{modalVer.id} — {modalVer.cliente}</div>
                </div>
                <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
                  <button onClick={()=>exportarPDF(modalVer)}
                    style={{background:"#3b82f6",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,padding:"8px 14px"}}>
                    {t("orcamentos.exportar_pdf")}
                  </button>
                  {arquivados.includes(modalVer.id)
                    ? <button onClick={()=>desarquivar(modalVer.id)}
                        style={{background:"#22c55e22",border:"1px solid #22c55e",borderRadius:8,color:"#22c55e",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>
                        {t("orcamentos.desarquivar")}
                      </button>
                    : <button onClick={()=>arquivar(modalVer.id)}
                        style={{background:"#f59e0b22",border:"1px solid #f59e0b",borderRadius:8,color:"#f59e0b",cursor:"pointer",fontSize:12,padding:"8px 14px"}}>
                        {t("orcamentos.arquivar")}
                      </button>
                  }
                  <button onClick={()=>setModalVer(null)}
                    style={{background:"var(--bg3)",border:"none",borderRadius:8,color:"var(--text2)",cursor:"pointer",fontSize:20,padding:"4px 12px"}}>x</button>
                </div>
              </div>

              <div style={{display:"grid",gap:12,gridTemplateColumns:"repeat(auto-fit,minmax(140px,1fr))",marginBottom:20}}>
                {[[tSeg("orcamentos.info_veiculo"),modalVer.veiculo],[t("orcamentos.info_placa"),modalVer.placa||"—"],[t("orcamentos.info_status"),STATUS_LABEL(modalVer.status)],[t("orcamentos.info_data"),modalVer.criada||"—"],[t("orcamentos.info_tecnico"),modalVer.tecnico||"—"],[t("orcamentos.info_total"),"R$ "+(modalVer.total||0).toLocaleString("pt-BR",{minimumFractionDigits:2})]].map(([l,v])=>(
                  <div key={l} style={{background:"var(--bg3)",borderRadius:8,padding:12}}>
                    <div style={{color:"var(--text3)",fontSize:10,fontWeight:700,marginBottom:2,textTransform:"uppercase"}}>{l}</div>
                    <div style={{fontSize:13,fontWeight:600}}>{v}</div>
                  </div>
                ))}
              </div>

              {modalVer.orcamento && (() => {
                let orc = null;
                try { orc = JSON.parse(modalVer.orcamento); } catch{}
                if(!orc) return null;
                return (
                  <div>
                    <div style={{color:"var(--text3)",fontSize:11,fontWeight:700,marginBottom:10,textTransform:"uppercase"}}>{t("orcamentos.itens_do_orcamento")}</div>
                    <table style={{borderCollapse:"collapse",width:"100%",marginBottom:16}}>
                      <thead><tr style={{background:"var(--bg3)"}}>
                        {[t("orcamentos.col_servico_peca"),t("orcamentos.col_qtd"),t("orcamentos.col_valor_unit"),t("orcamentos.col_total")].map(h=><th key={h} style={{color:"var(--text2)",fontSize:11,fontWeight:700,padding:"8px 12px",textAlign:"left"}}>{h}</th>)}
                      </tr></thead>
                      <tbody>
                        {(orc.itens||[]).map((item,i)=>(
                          <tr key={i} style={{borderBottom:"1px solid var(--border)"}}>
                            <td style={{fontSize:13,padding:"10px 12px"}}>{item.nome}</td>
                            <td style={{fontSize:13,padding:"10px 12px"}}>{item.qtd||1}</td>
                            <td style={{fontSize:13,padding:"10px 12px"}}>R$ {(Number(item.preco)/(item.qtd||1)).toFixed(2)}</td>
                            <td style={{fontSize:13,fontWeight:600,padding:"10px 12px"}}>R$ {Number(item.preco).toFixed(2)}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                    <div style={{display:"flex",justifyContent:"flex-end",marginBottom:16}}>
                      <div style={{background:"var(--bg3)",borderRadius:8,padding:"14px 20px",textAlign:"right",minWidth:220}}>
                        <div style={{color:"var(--text3)",fontSize:11}}>{t("orcamentos.total_do_orcamento")}</div>
                        <div style={{color:"#22c55e",fontSize:22,fontWeight:800}}>R$ {(modalVer.total||0).toLocaleString("pt-BR",{minimumFractionDigits:2})}</div>
                      </div>
                    </div>
                    {orc.fotos&&orc.fotos.length>0&&(
                      <div>
                        <div style={{color:"var(--text3)",fontSize:11,fontWeight:700,marginBottom:10,textTransform:"uppercase"}}>{t("orcamentos.registro_fotografico")}</div>
                        <div style={{display:"grid",gap:8,gridTemplateColumns:"repeat(auto-fill,minmax(150px,1fr))"}}>
                          {orc.fotos.map((foto,i)=>(
                            <div key={i} style={{borderRadius:8,overflow:"hidden",border:"1px solid var(--border)"}}>
                              <img src={foto.url||foto} alt={t("orcamentos.foto_n",{n:i+1})} style={{height:120,objectFit:"cover",width:"100%"}} />
                              {foto.descricao&&<div style={{background:"var(--bg3)",color:"var(--text2)",fontSize:11,padding:"4px 8px"}}>{foto.descricao}</div>}
                            </div>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                );
              })()}
            </div>
          </div>
        )}

        {/* CONFIRM LIMPAR */}
        {confirmLimpar && (
          <div style={{alignItems:"center",background:"#0009",bottom:0,display:"flex",justifyContent:"center",left:0,position:"fixed",right:0,top:0,zIndex:1100}}>
            <div style={{background:"var(--bg)",borderRadius:16,padding:28,maxWidth:400,width:"100%",margin:20}}>
              <div style={{fontSize:16,fontWeight:700,marginBottom:8}}>{t("orcamentos.confirm_limpar_titulo")}</div>
              <div style={{color:"var(--text2)",fontSize:13,marginBottom:20}}>{t("orcamentos.confirm_limpar_desc")}</div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>setConfirmLimpar(false)} style={{background:"var(--bg3)",border:"1px solid var(--border)",borderRadius:8,color:"var(--text2)",cursor:"pointer",flex:1,padding:"10px"}}>{t("common.cancelar")}</button>
                <button onClick={limparArquivados} style={{background:"#ef4444",border:"none",borderRadius:8,color:"#fff",cursor:"pointer",flex:1,fontWeight:700,padding:"10px"}}>{t("orcamentos.limpar")}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </Layout>
  );
}
